import React from 'react';
import { DotsLoader } from '../../dots-loader/index.js';
import { ListElemText } from '../list-content-elements/index.js';
import '../../../../_tslib-7a01aab4.js';
import '../../../../index-e609ebf3.js';
import '../../../../_commonjsHelpers-17aad09c.js';

var ListItemRowLoader = function () {
    return (React.createElement("div", { className: 'list-item-row-loader' },
        React.createElement(ListElemText, { forSaving: true },
            React.createElement(DotsLoader, null))));
};

export { ListItemRowLoader };
